import { render, staticRenderFns } from "./page-users.vue?vue&type=template&id=6aaabaa1"
import script from "./page-users.vue?vue&type=script&lang=ts"
export * from "./page-users.vue?vue&type=script&lang=ts"
import style0 from "./page-users.vue?vue&type=style&index=0&id=6aaabaa1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports